import React from 'react';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import BootstrapTable from 'react-bootstrap-table-next';

import { Col, Row } from 'reactstrap';

import { PropTypes } from 'prop-types';
import { gigaBytesDataRowsRequestSettings } from './RequestConstants';

import { format_2_digits_zero_sensitive, roundToGb } from '../../../util/NumberFormatter';
import { showAlwaysOverflowTooltip } from '../OverflowTooltip/OverflowTooltip';
import moment from 'moment';
import { liveCaptionsBillingRequestSettings } from './RequestConstants';

const getColumnsOptions = (showLCBilling) => {
   const colSettings = [
      {
         text: 'Name',
         dataField: 'name',
         sort: true,
         align: 'right',
         headerAlign: 'right',
         headerClasses: 'headlessTable',
      },
      {
         text: 'Hash',
         dataField: 'hash',
         sort: true,
         headerClasses: 'headlessTable',
      },
   ];

   if (showLCBilling) {
      // Billing columns (Hours)
      liveCaptionsBillingRequestSettings.forEach((col) => {
         if (col.tableHeaderText) {
            colSettings.push({
               text: col.tableHeaderText,
               dataField: col.shortDesc,
               align: 'center',
               headerAlign: 'center',
               headerClasses: 'headlessTable',
               formatter: col.formatter || ((cell) => cell ?? '—'),
               headerFormatter: (col) => showAlwaysOverflowTooltip(col.text),
            });
         }
      });
   } else {
      // Regular columns (GB)
      gigaBytesDataRowsRequestSettings.forEach((col) => {
         if (col.tableHeaderText) {
            colSettings.push({
               text: col.tableHeaderText,
               dataField: col.shortDesc,
               align: 'center',
               headerAlign: 'center',
               headerClasses: 'headlessTable',
               formatter: roundToGb,
               headerFormatter: (col) => showAlwaysOverflowTooltip(col.text),
            });
         }
      });

      colSettings.push({
         text: 'Ratio player/ server metrics current month',
         dataField: 'ratios',
         align: 'center',
         headerAlign: 'center',
         headerClasses: 'headlessTable',
         formatter: (col) => format_2_digits_zero_sensitive(col),
         headerFormatter: (col) => showAlwaysOverflowTooltip(col.text),
      });
   }
   colSettings.push({
      text: 'Created at',
      dataField: 'createdAt',
      align: 'center',
      headerAlign: 'center',
      headerClasses: 'headlessTable',
      formatter: (stdDateStr) => (stdDateStr ? moment.utc(stdDateStr).format('MMMM Do YYYY') : '—'),
      headerFormatter: (col) => showAlwaysOverflowTooltip(col.text),
   });

   colSettings.push({
      text: 'Access level',
      dataField: 'access',
      align: 'center',
      headerAlign: 'center',
      headerClasses: 'headlessTable',
      headerFormatter: (col) => showAlwaysOverflowTooltip(col.text),
   });
   return colSettings;
};

function SelectedOption({ selectedOrga, showLCBilling }) {
   const columnSettings = getColumnsOptions(showLCBilling);
   return (
      <>
         <Row>
            <Col className='col-3' style={{ marginBottom: 10 }}>
               <strong>Selected Organisation</strong>
            </Col>
         </Row>
         <Row>
            <Col>
               <BootstrapTable
                  classes='table-responsive-lg'
                  bootstrap4
                  rowClasses={'bg-primary'}
                  bordered={true}
                  columns={columnSettings}
                  keyField='hash'
                  data={selectedOrga}
                  id={'selectedOptionTable'}
               />
            </Col>
         </Row>
      </>
   );
}

SelectedOption.propTypes = {
   selectedOrga: PropTypes.array,
   showLCBilling: PropTypes.bool,
};

export default SelectedOption;
